import { BannerSliderStyleTokens } from "@omni/ui/brand/bannerSlider/bannerSlider.tokens";
import { UIBannerSlider } from "@omni/ui/components/BannerSlider/bannerSlider.styles";
import { tv } from "tailwind-variants";

export const BannerSliderStyles: BannerSliderStyleTokens = {
    navButtonColor: "gray"
};

export const bannerSlider = tv({
    extend: UIBannerSlider,
    slots: {
        slider_navButton: [
            "tw:hidden tw:rounded-none! tw:absolute tw:top-1/2 tw:translate-y-[-50%] tw:layer-base/[2] tw:min-h-8 tw:min-w-8 tw:justify-center tw:items-center tw:text-primary tw:cursor-pointer tw:text-3xl!",
            "tw:md:flex",
            "tw:disabled:cursor-default tw:disabled:opacity-20 tw:disabled:text-primary",
            "tw:hover:bg-white!",
            "tw:focus:bg-white! tw:focus:ring-0"
        ],
        slider_navButton_icon: "las"
    },
    variants: {
        type: {
            left: {
                slider_navButton_icon: "la-angle-left"
            },
            right: {
                slider_navButton_icon: "la-angle-right"
            }
        }
    }
});
